import React from 'react';
import CommonSidebar from "../Common/CommonSidebar";

//icons
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ForkLeftIcon from '@mui/icons-material/ForkLeft';
import KeyIcon from '@mui/icons-material/Key';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import ChecklistIcon from '@mui/icons-material/Checklist';
import QuizIcon from '@mui/icons-material/Quiz';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';


class AdminSidebar extends React.Component {
    render() {
        return(
            <CommonSidebar
                groups={[
                    {
                        title: 'Администрирование',
                        items: [
                            {
                                title: 'Бизнес-процессы',
                                link: '/admin/delivery/',
                                icon: AccountTreeIcon,
                            },
                            {
                                title: 'Статистика БП',
                                link: '/admin/delivery_stats/',
                                icon: QueryStatsIcon,
                            },
                            {
                                title: 'Маршруты',
                                link: '/admin/route/',
                                icon: ForkLeftIcon,
                            },
                            {
                                title: 'Права',
                                link: '/admin/permission/',
                                icon: KeyIcon,
                            },
                            {
                                title: 'UltimateAdmin',
                                link: '/admin/ultimate/',
                                icon: AutoAwesomeIcon,
                            },
                        ]
                    },
                    {
                        title: 'Чек-листы',
                        items: [
                            {
                                title: 'Типы',
                                link: '/admin/checklist_type/',
                                icon: ChecklistIcon,
                            },
                            {
                                title: 'Вопросы',
                                link: '/admin/checklist_question/',
                                icon: QuizIcon,
                            },
                            {
                                title: 'Варианты ответа',
                                link: '/admin/checklist_option/',
                                icon: QuestionAnswerIcon,
                            },
                        ]
                    },
                ]}
            />
        )
    }
}

export default AdminSidebar;